/** Modelos de autenticación y autorización. */

export interface Token {
  access: string;
  refresh: string;
}

export enum Rol {
  ADMIN = 'admin',
  OPERADOR = 'operador',
  CONDUCTOR = 'conductor',
  PROVEEDOR = 'proveedor',
  CLIENTE = 'cliente',
}

/**
 * Objetos sobre los que se otorgan permisos (nombres de modelo del backend).
 *
 * No hay `conductor`: un conductor es un Usuario con ese rol, no un modelo.
 */
export enum Objeto {
  CLIENTE = 'cliente',
  PROVEEDOR = 'proveedor',
  PRODUCTO = 'producto',
  DESTINO = 'destino',
  PUNTO_RECOGIDA = 'puntorecogida',
  RECOGIDA = 'recogida',
  ENTREGA = 'entrega',
  RUTA = 'ruta',
  PAQUETE = 'paquete',
}

export enum Permiso {
  VER = 'view',
  VER_MASIVO = 'view_massive',
  CREAR = 'add',
  EDITAR = 'change',
  ELIMINAR = 'delete',
  /** Permiso de acción de Paquete: dividir una caja en varios. */
  DIVIDIR = 'split',
}

/** El backend devuelve los permisos agrupados por objeto: { paquete: ['view', 'add'] }. */
export type Permisos = Partial<Record<Objeto, string[]>>;

export interface PermisosDTO {
  rol: Rol;
  permisos: Permisos;
}

/**
 * Regla de autorización de una ruta o de un botón.
 * Si `permisos` es un arreglo, basta con cumplir una de las opciones (OR).
 */
export interface Autorizacion {
  roles?: Rol[];
  permisos?: Permisos | Permisos[];
}

export interface UsuarioDTO {
  id: number;
  username: string;
  nombre: string;
  email: string | null;
  telefono: string;
  rol: Rol;
  rol_display: string;
  acceso: boolean;
  proveedor: number | null;
  cliente: number | null;
}

/** Respuesta paginada estándar de DRF (LimitOffsetPagination). */
export interface ListaDTO<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export type Parametros = Record<string, string | number | boolean>;
